import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  Rating,
  Chip,
  Container,
  IconButton,
  // useTheme,
  // useMediaQuery,
  // Badge
} from '@mui/material';
import {
  ShoppingCart as ShoppingCartIcon,
  // Favorite as FavoriteIcon,
  FavoriteBorder as FavoriteBorderIcon,
  LocalFireDepartment as FireIcon
} from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

// نموذج للمنتجات الأكثر مبيعاً
const bestSellerProducts = [
  {
    id: 101,
    name: 'سماعات AirPods Pro',
    description: 'سماعات لاسلكية مع ميزة إلغاء الضوضاء',
    price: 899,
    oldPrice: 1099,
    image: 'https://via.placeholder.com/300x300?text=AirPods+Pro',
    rating: 4.7,
    reviewCount: 230,
    isNew: false,
    discount: 18,
    category: 'الإكسسوارات',
    soldCount: 1250
  },
  {
    id: 102,
    name: 'جهاز PlayStation 5',
    description: 'جهاز ألعاب منزلي مع وحدة تحكم لاسلكية',
    price: 2499,
    oldPrice: 2699,
    image: 'https://via.placeholder.com/300x300?text=PlayStation+5',
    rating: 4.8,
    reviewCount: 320,
    isNew: false,
    discount: 7,
    category: 'أجهزة الألعاب',
    soldCount: 980
  },
  {
    id: 103,
    name: 'هاتف ذكي Galaxy S23 Ultra',
    description: 'هاتف ذكي بشاشة 6.8 بوصة وكاميرا 200 ميجابكسل',
    price: 4999,
    oldPrice: 5499,
    image: 'https://via.placeholder.com/300x300?text=Galaxy+S23',
    rating: 4.8,
    reviewCount: 120,
    isNew: true,
    discount: 9,
    category: 'الهواتف الذكية',
    soldCount: 850
  },
  {
    id: 104,
    name: 'سماعة JBL Charge 5',
    description: 'سماعة بلوتوث مقاومة للماء',
    price: 599,
    oldPrice: 699,
    image: 'https://via.placeholder.com/300x300?text=JBL+Charge',
    rating: 4.4,
    reviewCount: 112,
    isNew: false,
    discount: 14,
    category: 'السماعات',
    soldCount: 720
  }
];

interface BestSellersProps {
  title?: string;
  maxItems?: number;
  showBadge?: boolean;
}

const BestSellers: React.FC<BestSellersProps> = ({
  title = 'الأكثر مبيعاً',
  maxItems = 4,
  showBadge = true
}) => {
  // يمكن استخدام هذه المتغيرات لاحقاً لتحسين تجربة المستخدم على الأجهزة المختلفة
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  // تحديد عدد المنتجات المعروضة
  const displayedProducts = bestSellerProducts.slice(0, maxItems);

  // تنسيق السعر
  const formatPrice = (price: number) => {
    return price.toLocaleString('ar-SA') + ' ر.س';
  };

  return (
    <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4, lg: 5 } }}>
      <Box sx={{ mb: 6 }}>
        {/* عنوان القسم */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            className="section-title"
            sx={{
              fontWeight: 'bold',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              '&:after': {
                content: '""',
                position: 'absolute',
                bottom: -8,
                right: 0,
                width: 60,
                height: 4,
                backgroundColor: 'secondary.main',
                borderRadius: 2
              }
            }}
          >
            {showBadge && (
              <FireIcon color="secondary" sx={{ mr: 1, fontSize: 32 }} />
            )}
            {title}
          </Typography>

          <Button
            component={RouterLink}
            to="/products/best-sellers"
            color="secondary"
            sx={{ fontWeight: 'bold' }}
          >
            عرض الكل
          </Button>
        </Box>

        {/* شبكة المنتجات */}
        <Grid container spacing={3}>
          {displayedProducts.map((product, index) => (
            <Grid item xs={12} sm={6} md={3} key={product.id}>
              <Card
                className="product-card"
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                  }
                }}
              >
                {/* شارة الترتيب */}
                {showBadge && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 12,
                      left: 12,
                      width: 36,
                      height: 36,
                      borderRadius: '50%',
                      backgroundColor: 'secondary.main',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 'bold',
                      zIndex: 2,
                      boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                    }}
                  >
                    {index + 1}
                  </Box>
                )}

                {/* شارة الخصم */}
                {product.discount > 0 && (
                  <Chip
                    label={`خصم ${product.discount}%`}
                    color="secondary"
                    size="small"
                    sx={{
                      position: 'absolute',
                      top: 12,
                      right: 12,
                      fontWeight: 'bold',
                      zIndex: 1
                    }}
                  />
                )}

                {/* صورة المنتج */}
                <Box sx={{ position: 'relative' }}>
                  <CardMedia
                    component="img"
                    image={product.image}
                    alt={product.name}
                    sx={{
                      height: 200,
                      objectFit: 'contain',
                      p: 2,
                      backgroundColor: '#f5f5f5'
                    }}
                  />

                  {/* أزرار سريعة */}
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      display: 'flex',
                      justifyContent: 'center',
                      gap: 1,
                      p: 1,
                      backgroundColor: 'rgba(255,255,255,0.9)',
                      transform: 'translateY(100%)',
                      opacity: 0,
                      transition: 'all 0.3s ease',
                      '.product-card:hover &': {
                        transform: 'translateY(0)',
                        opacity: 1
                      }
                    }}
                  >
                    <IconButton size="small" color="primary">
                      <ShoppingCartIcon />
                    </IconButton>
                    <IconButton size="small" color="secondary">
                      <FavoriteBorderIcon />
                    </IconButton>
                  </Box>
                </Box>

                {/* محتوى المنتج */}
                <CardContent sx={{ flexGrow: 1, pt: 2 }}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1 }}
                  >
                    {product.category}
                  </Typography>

                  <Typography
                    variant="h6"
                    component={RouterLink}
                    to={`/product/${product.id}`}
                    sx={{
                      fontWeight: 'bold',
                      color: 'text.primary',
                      textDecoration: 'none',
                      mb: 1,
                      height: 48,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      '&:hover': {
                        color: 'secondary.main'
                      }
                    }}
                  >
                    {product.name}
                  </Typography>

                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Rating
                      value={product.rating}
                      precision={0.1}
                      size="small"
                      readOnly
                    />
                    <Typography variant="body2" sx={{ mr: 1, color: 'text.secondary' }}>
                      ({product.reviewCount})
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography
                      variant="h6"
                      color="secondary"
                      sx={{ fontWeight: 'bold' }}
                    >
                      {formatPrice(product.price)}
                    </Typography>

                    {product.oldPrice > product.price && (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mr: 1, textDecoration: 'line-through' }}
                      >
                        {formatPrice(product.oldPrice)}
                      </Typography>
                    )}
                  </Box>

                  {/* عدد المبيعات */}
                  <Typography
                    variant="body2"
                    sx={{
                      mt: 1,
                      color: 'text.secondary',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <FireIcon color="secondary" sx={{ fontSize: 16, mr: 0.5 }} />
                    تم بيع {product.soldCount.toLocaleString('ar-SA')} قطعة
                  </Typography>
                </CardContent>

                {/* أزرار المنتج */}
                <CardActions sx={{ p: 2, pt: 0 }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    startIcon={<ShoppingCartIcon />}
                    sx={{ fontWeight: 'bold' }}
                  >
                    أضف للسلة
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default BestSellers;
